var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1120({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.52,5.86a1.63,1.63,0,0,0-1.17.49,1.65,1.65,0,1,0,1.17-.49Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,1,1.94,4.5v7L8,15l6.06-3.5v-7Zm3,10a.48.48,0,0,1-.7,0L9,9.72a2.65,2.65,0,0,1-1.5.46A2.66,2.66,0,0,1,5.64,5.64,2.66,2.66,0,0,1,9.72,9L11,10.29A.48.48,0,0,1,11,11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1120);
export default __webpack_public_path__ + "static/media/Symbolpack_1_120.c05e03bd3f42066aff9fee50d8978674.svg";
export { ForwardRef as ReactComponent };